import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';

const printMode = createSlice({
  initialState,
  name: 'printMode',
  reducers: {
    setPrintMode: (
      state,
      { payload },
    ) => ({
      ...state,
      isPrinting: payload,
    }),
  },
});
export const { setPrintMode } = printMode.actions;

export default printMode.reducer;
